var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canView && _vm.recordId)?_c('v-expansion-panel',[_c('v-expansion-panel-header',[_vm._v("Zones")]),_c('v-expansion-panel-content',[_c('ZoneAssignmentsField',{attrs:{"record-type":_vm.recordType,"record-id":_vm.recordId}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }